/** TanStack Query hooks for the candidate Stage 2 surface (Plan 04-06). */
import { useMutation, useQuery } from "@tanstack/react-query";

import * as api from "./api";

/**
 * Active Ley-9877 video consent (CAN-08). Gated on a present stage_2_token (the layout
 * persists the URL param before children render). Pins i18n.changeLanguage in the layout.
 */
export function useVideoConsentQuery() {
  return useQuery({
    queryKey: ["stage2-video-consent"],
    queryFn: api.getVideoConsent,
    enabled: !!api.getStage2SessionToken(),
    retry: 1,
  });
}

/** Accept the video consent (POST, no body). On success the candidate proceeds to upload. */
export function useAcceptVideoConsent() {
  return useMutation({ mutationFn: api.acceptVideoConsent });
}

/** One-way confirmation state (CAN-12). Used by the confirmation screen + salary refetch. */
export function useStage2StateQuery() {
  return useQuery({
    queryKey: ["stage2-state"],
    queryFn: api.getStage2State,
    enabled: !!api.getStage2SessionToken(),
    retry: false,
  });
}

/** Standalone Stage 2 salary revision (CAN-11). */
export function usePostStage2Salary() {
  return useMutation({ mutationFn: api.postStage2Salary });
}
